import { HModules, HCF, HLink, HUtils } from "@macashipo/mlib"
import MyPageOne from "./MyPage"
import MyUIOne from "./MyUI"
import { HRoutes } from "src/helpers/Flows/Routes"
const ModuleQLProject = {
  _key: "qlproject",
  _fnList: {},
  _config: {},
  getMyKey: () => {
    return "qlproject"
  },
  runAfterInit: HConfig => {
    HModules.initDefault(ModuleQLProject, { MyUIOne, MyPageOne })
    // HRoutes.listIdNoSidebar["pjdailytaskv2"] = true
    // HRoutes.listIdNoSidebar["pjdailytaskv2new"] = true
    // HRoutes.listIdNoHeader["pjdailytaskv2"] = true
    HRoutes.listIdNoFooter["pjdailytaskv2"] = true
    HRoutes.listIdNoFooter["pjdailytaskv2new"] = true
    // HRoutes.listIdMiniSidebar["pjdailytaskv2"] = true
    // HRoutes.listIdMiniSidebar["pjdailytaskv2"] = true
    HUtils.runFuntion(HConfig, "addPrivateRoutes", [
      [
        {
          Id: "pjdailytaskdetail",
          UIUrl: "/dailytasks_old/:taskid",
          UIType: "prj_dailytask_detail",
        },
        {
          Id: "pjdailytask",
          UIUrl: "/dailytasks_old",
          UIType: "prj_dailytask",
        },
        {
          Id: "pjdailytaskv2",
          UIUrl: "/dailytasks",
          Config: JSON.stringify({}),
          UIType: "prj_dailytask_v2",
        },
        {
          Id: "pjdailytaskv2new",
          UIUrl: "/dailytasksv2",
          Config: JSON.stringify({}),
          UIType: "prj_dailytask_v2",
        },
        {
          Id: "pjmanager",
          UIUrl: "/pj/:pj",
          UIType: "prjmanager",
        },
        {
          Id: "pjmanager",
          UIUrl: "/pj",
          UIType: "prjmanager",
        },
        {
          Id: "pjtaskdetail",
          UIUrl: "/pjtask/:taskid",
          UIType: "prj_dailytask_detail",
        },
      ],
    ])
  },
}

export default ModuleQLProject
